import React, { useState, createContext, useContext } from "react";

// context for managing registration data in Register screen
const initalState = {
    queryType: 'STR',
};

const QueryTypeContext = createContext(initalState);

export const QueryTypeProvider = ({ children }) => {
  const [queryType, setQueryType] = useState('STR'); // Stores questions and answers
  return (
    <QueryTypeContext.Provider
      value={{
        queryType, setQueryType
      }}
    >
      {/* {renderComponent()} */}
      {children}
    </QueryTypeContext.Provider>
  );
};

export const useQueryTypeContext = () => useContext(QueryTypeContext);
